module.exports = __webpack_public_path__ + "static/media/(V)_MG_5463_-_Pro-Natura_-_Moda_Masculina_Infantil.afe3a86f.jpg";